import {
  FintechProductV2,
  type FintechProductProps,
  FintechProductOptionsSection,
} from "@b2bportal/core-fintech-ui";
import type { FiatPrice } from "@b2bportal/core-types";

export interface DisruptionFintechProductOptionsSectionItemProps {
  optionType: "attached" | "declined";
  pricePerPaxLocalized: FiatPrice;
}

export type DisruptionFintechProductProps = Omit<
  FintechProductProps,
  "selectionOffers"
> & {
  selectionOffers: DisruptionFintechProductOptionsSectionItemProps[];
  continueClicked: boolean;
};

export const DisruptionFintechProduct = (
  props: DisruptionFintechProductProps
) => {
  return (
    <FintechProductV2
      {...props}
      footerSubtitle={props.footerSubtitle}
      infoLinks={{
        howItWorksDialog: props.howItWorksDialog,
        viewTermsLink: props.viewTermsLink,
        ui: props.infoLinksUI,
      }}
      selectionOffers={{
        options: props.selectionOffers,
        Component: FintechProductOptionsSection,
      }}
    />
  );
};
